/**
 * @param {String} term
 * @param {String} type
 * @returns {Object}
 */
import React, {Component} from 'react';
import Select2 from 'react-select2-wrapper';
import {connect} from 'react-redux';
import {getCurrentThread} from '../../redux/selectors';
import {threadOwnerUpdate} from '../../redux/actions';
import {getSelect2Locale} from '../../util';

class ThreadOwnerEdit extends Component {
    constructor(props) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
        this.onUnselect = this.onUnselect.bind(this);
    }

    onSelect(e) {
        this.props.updateThreadOwner(parseInt(e.params.data.id));
    }

    onUnselect() {
        this.props.updateThreadOwner(null);
    }

    render() {
        const {isLoading} = this.props;

        return (
            <Select2 value={this.props.thread.owner}
                     disabled={isLoading}
                     onSelect={this.onSelect}
                     onUnselect={this.onUnselect}
                     data={
                         this.props.owner ? [{
                             id: this.props.owner.id,
                             text: (() => {
                                 const parts = [this.props.owner.mark, this.props.owner.username].filter(Boolean);
                                 return this.props.owner.name + (parts.length ? ` (${parts.join(', ')})` : '');
                             })(),
                         }] : []
                     }
                     options={{
                         allowClear: true,
                         width: '100%',
                         theme: 'bootstrap4',
                         language: getSelect2Locale(),
                         ajax: {
                             url: Routing.generate('imatic_communicator_thread_selectowner', {thread: this.props.thread.id}),
                             dataType: 'json',
                             delay: 300,
                             processResults: (data) => ({results: data}),
                             data: (params) => {
                                 return {filter: {search: {value: params.term}}};
                             },
                         },
                     }}
            />
        );
    }
}

export default connect(
    (state) => {
        const thread = getCurrentThread(state);

        return {
            thread,
            owner: state.getIn(['participants', thread.owner]),
            isLoading: state.getIn(['threadOwnerMeta', 'loading']),
            hasError: state.getIn(['threadOwnerMeta', 'error']) !== null,
        };
    },
    (dispatch) => ({
        updateThreadOwner(newOwnerId) {
            return dispatch(threadOwnerUpdate(newOwnerId));
        },
    }),
)(ThreadOwnerEdit);
